import TileRadarLayer from "./TileRadarLayer";
import scope from "../../app/rootScope";

const tileRadarLayerIntance = new TileRadarLayer(scope.tileServer +'/img/foreground/gray/{z}/{x}/{y}'+(scope.isRetina ? "@2x" : "")+'.png');

export default tileRadarLayerIntance;
